import { useLayoutEffect, useRef, useState } from "react";

/**
 * Determines whether is visible. Hook does nothing when @param isVisibleByDefault is true.
 * Truth table row will never become hidden once it became visible.
 */
export function useVisibleRow(isVisibleByDefault: boolean) {
  const [isVisible, setIsVisible] = useState(isVisibleByDefault);
  const rowRef = useRef<HTMLTableRowElement>(null);

  useLayoutEffect(() => {
    if (isVisibleByDefault || rowRef.current == null) {
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      const isRowVisible = entries[0].isIntersecting;
      setIsVisible(isRowVisible);
      if (isRowVisible) {
        observer.disconnect();
      }
    }, {
      root: rowRef.current.closest('.tt-grid-container'),
      threshold: .1,
    });

    observer.observe(rowRef.current);
    return () => {
      observer?.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { rowRef, isVisible };
}
